import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { Subscription } from 'rxjs/Rx';

import { DBService } from '../../service';
import { RDSAnalysisData } from '../../model/analysis-details.model';
import { StorageService } from '../../service/storage.service';
import _moment, { default as _rollupMoment } from 'moment';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};



@Component({
  selector: 'app-previous-analysis',
  templateUrl: './previous-analysis.component.html',
  styleUrls: ['./previous-analysis.component.scss'],
  providers: [{
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  },
  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})



export class PreviousAnalysisComponent implements OnInit, OnDestroy {

  pageTitle = 'Previous Activities';
  previousAnalysisKeys: RDSAnalysisData[] = [];
  pageLoaded = false;
  private rdsAnalysisDataSubscription?: Subscription;
  startDate: string | undefined;
  endDate: string | undefined;
  maxDate = new Date();
  auditFlag = false;
  dateRangeStart?: moment.Moment | null;
  dateRangeEnd?: moment.Moment | null;
  userAttributes?: string | null;
  dataCompile=false;

  constructor(private _sharedService: SharedService,
    private dbService: DBService,
    private storageService: StorageService,
  ) {
    this._sharedService.emitChange(this.pageTitle);
  }

  ngOnInit(): void {
    this.userAttributes = this.storageService.get('access'); 
       if (this.userAttributes == 'QA') {
        this.pageLoaded = false;
      }

    else if (this.userAttributes == 'GA' || this.userAttributes == 'SU' || this.userAttributes == 'PI') {
      this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);
      this.rdsAnalysisDataSubscription = this.dbService.rdsAnalysisData.subscribe(
        (data: RDSAnalysisData[]) => {
          this.previousAnalysisKeys = data;
          this.pageLoaded = true;
        });
    }
  
  }

  selectedDates() {
    this.startDate = this.dateRangeStart?.format('MM/DD/YYYY');
    this.endDate = this.dateRangeEnd?.format('MM/DD/YYYY');
    this.previousAnalysisKeys = [];
    this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);
  }


  clearSelectedDates() {
    this.previousAnalysisKeys = [];
    this.dateRangeEnd = null;
    this.dateRangeStart = null;
    this.startDate = 'none';
    this.endDate = 'none';
    this.dbService.getAnalysis(this.userAttributes, this.startDate, this.endDate, this.auditFlag,this.dataCompile);

  }

  ngOnDestroy() {
    if (this.rdsAnalysisDataSubscription) {
  this.rdsAnalysisDataSubscription.unsubscribe();
    }
  }

}
